document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;

  const closeLayer = (layer) => {
    if (!layer) return;
    layer.classList.remove('is-open');
    layer.setAttribute('aria-hidden', 'true');
    body.style.overflow = '';
  };

  document.querySelectorAll('[data-open-layer]').forEach((button) => {
    button.addEventListener('click', () => {
      const layer = document.querySelector(button.dataset.openLayer);
      if (!layer) return;
      layer.classList.add('is-open');
      layer.setAttribute('aria-hidden', 'false');
      body.style.overflow = 'hidden';
    });
  });

  document.querySelectorAll('[data-close-layer]').forEach((button) => {
    button.addEventListener('click', () => closeLayer(button.closest('.mobile-drawer, .search-panel')));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.mobile-drawer.is-open, .search-panel.is-open').forEach(closeLayer);
    }
  });

  const header = document.querySelector('[data-site-header]');
  if (header && body.classList.contains('template-index')) {
    const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  document.querySelectorAll('[data-slideshow]').forEach((slideshow) => {
    const slides = [...slideshow.querySelectorAll('[data-slide]')];
    const dots = [...slideshow.querySelectorAll('[data-slide-dot]')];
    if (slides.length < 2) return;

    let index = 0;
    let timer;
    const interval = Number(slideshow.dataset.interval || 5000);
    const autoplay = slideshow.dataset.autoplay === 'true';

    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    const restart = () => {
      if (!autoplay) return;
      window.clearInterval(timer);
      timer = window.setInterval(() => show(index + 1), interval);
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        show(Number(dot.dataset.slideDot));
        restart();
      });
    });

    slideshow.addEventListener('mouseenter', () => window.clearInterval(timer));
    slideshow.addEventListener('mouseleave', restart);
    restart();
  });

  document.querySelectorAll('.featured-rail-section').forEach((section) => {
    const rail = section.querySelector('[data-product-rail]');
    if (!rail) return;
    section.querySelector('[data-rail-prev]')?.addEventListener('click', () => {
      rail.scrollBy({ left: -rail.clientWidth * 0.8, behavior: 'smooth' });
    });
    section.querySelector('[data-rail-next]')?.addEventListener('click', () => {
      rail.scrollBy({ left: rail.clientWidth * 0.8, behavior: 'smooth' });
    });
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-quick-add]');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const original = button?.textContent;
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('Unable to add item');

      const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await cartResponse.json();
      document.querySelectorAll('[data-cart-count]').forEach((count) => {
        count.textContent = cart.item_count;
        count.classList.toggle('is-empty', cart.item_count === 0);
      });

      if (button) button.textContent = 'Added';
      window.setTimeout(() => {
        if (button) {
          button.disabled = false;
          button.textContent = original;
        }
      }, 1200);
    } catch (error) {
      form.submit();
    }
  });
});
